function isHostComponent(element) {
  return typeof element == "string";
}
export {
  isHostComponent
};
//# sourceMappingURL=isHostComponent.js.map
